import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Router from "./Router";

function App() {
  return <Router />;
}

export default App;
